/**
 * Extracted from sections/ns-exercise-tabbed-carousel.liquid (inline <script> at line 960).
 * Config bridge: window.__nsExerciseTabbedCarouselSections, keyed by section id — the inline block
 * only needed Liquid for the section id, so the id is now handed over as
 * data and the logic runs from a cacheable, deferred asset instead of
 * being parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances still each initialise.
 */

(function () {
  var cfg = window.__nsExerciseTabbedCarouselSections = window.__nsExerciseTabbedCarouselSections || {};
  function boot(sectionId, settings) {
  function tabbedGalleriesLayout () {
    let section = document.querySelector(`#shopify-section-${sectionId}`)
    let contentContainerAllEls = section.querySelectorAll('.ns-exercise-tabs-carousel-gallery')

    contentContainerAllEls.forEach(contentContainerEl => {
      let swiperWrapperEl = contentContainerEl.querySelector('[data-swiper-wrapper]')
      let swiperEl = contentContainerEl.querySelector('[data-swiper-container]')
      let swiperPaginationEl = contentContainerEl.querySelector('.swiper-pagination')
      let {
        layoutMobile,
        layoutDesktop,
        itemsPerRowDesktop,
        itemsPerRowMobile,
      } = contentContainerEl.dataset
    
      let tabbedGallerySwiper
      let sliderThumbnail
    
      function waitForSwiper(callback) {
        if (typeof Swiper !== 'undefined') {
          callback();
        } else {
          const checkInterval = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
              clearInterval(checkInterval);
              callback();
            }
          }, 100);
        }
      }

      function initializeSwiper () {
        if (tabbedGallerySwiper) return;

        sliderThumbnail = new Swiper(contentContainerEl.querySelector('[data-swiper-thumbnails-container]'), {
          slidesPerView: 'auto',
          // the reference design uses a flat 8px between thumbnails at every
          // width; swiper writes this as an inline margin on each slide, so it
          // is the single source of that gap (no CSS gap on the wrapper, which
          // would stack on top of it)
          spaceBetween: 8,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          breakpoints: {
            320: {
              spaceBetween: 8
            },
            480: {
              spaceBetween: 8
            },
            700: {
              spaceBetween: 8
            },
            1024: {
              spaceBetween: 8
            },
          },
        });

        tabbedGallerySwiper = new Swiper(swiperEl , {
          slidesPerView: 1.125,
          spaceBetween: 10,
          speed: 600,
          autoHeight: true,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            480: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            800: {
              slidesPerView: 1,
              spaceBetween: 25
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 30
            }
          },
          navigation: {
            nextEl: contentContainerEl.querySelector('.ns-exercise-tabs-carousel-gallery__swiper-button-next'),
            prevEl: contentContainerEl.querySelector('.ns-exercise-tabs-carousel-gallery__swiper-button-prev'),
          },
          pagination: {
            el: contentContainerEl.querySelector('.swiper-pagination'),
            clickable: true  
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          thumbs: {
            swiper: sliderThumbnail
          },
          on: {
            slideChange: function () {
              const currentIndex = this.activeIndex;
              const previousIndex = this.previousIndex;

              if (previousIndex) {
                let previousSlide = this.slides[previousIndex] 
                if (previousSlide && previousSlide.querySelector('video')) {
                  previousSlide.querySelector('video').pause();
                }
                if (previousSlide && previousSlide.querySelector('iframe')) {
                  let iframe = previousSlide.querySelector('iframe')
                  iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
                  // iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
                  // iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*'); 
                }
              }
            }
          }
        })
      }  

      // function callFunctionOnPreviousSlide(currentIndex, previousIndex) {
      //   console.log("Went to previous slide, now at index:", currentIndex, previousIndex);
      //   // Add your custom logic here
      // }
    
      function destroySwiper() {
        if (typeof tabbedGallerySwiper !== 'undefined') {
            tabbedGallerySwiper.destroy(true, true)
        }
      }

      waitForSwiper(() => {
        initializeSwiper()
      })
    })
  
    // active/deactive tab/gallery
    const galleryTabAllEls = section.querySelectorAll('.ns-exercise-tabs-carousel__tab-single');
    const galleryContentAllEls = section.querySelectorAll('.ns-exercise-tabs-carousel-gallery');

    function activateGalleryTab(galleryTab) {
      let clickedIndex = galleryTab.getAttribute('data-ns-gallery-tab-index');
    
      galleryTabAllEls.forEach(el => el.classList.remove('active'));
      galleryTabAllEls[clickedIndex].classList.add('active');

      galleryContentAllEls.forEach(el => el.classList.remove('active'));
      pauseAllVideos(galleryContentAllEls)
      galleryContentAllEls[clickedIndex].classList.add('active');
    }

    function pauseAllVideos(galleries) {
      if (galleries) {
        galleries.forEach((gallery) => {
          let galleryVideoEls = gallery.querySelectorAll('video')
          let galleryIframeEls = gallery.querySelectorAll('iframe')
          if (galleryVideoEls) {
            galleryVideoEls.forEach(el => el.pause())
          }
          if (galleryIframeEls) {
            galleryIframeEls.forEach(iframe => iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'))
            // iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
            // iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*'); 
          }
        });
      }
    }

    galleryTabAllEls.forEach(galleryTab => {
      galleryTab.addEventListener('click', () => {
        activateGalleryTab(galleryTab)
      });
    });

    if(galleryTabAllEls.length > 0) activateGalleryTab(galleryTabAllEls[0]);
 
  }

  
  tabbedGalleriesLayout()
  
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      tabbedGalleriesLayout()
    });
  }
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
